import { connect } from 'formik'
import { SectionItem } from '@features/shift-post-v2/components'
import { ShiftPostPage } from '@src/features/shift-post-v2/pages'
import { ShiftPostStep } from '@src/features/shift-post-v2/steps/steps.types'
import { Box, Colors, InputV2, Text } from '@pinchenterprisesnpm/friday-ui'
import { useModal } from '@src/hooks/useModal'
import { NumberUpshiftersModal } from '@src/features/shift-post-v2/steps/shift-details-step/components/upshifters-number-section/modals/number-upshifters-modal/number-upshifters-modal'
import { IUpshiftersNumberSectionProps } from './upshifters-number-section.types'

export const UpshiftersNumberSection = connect<IUpshiftersNumberSectionProps>(
  ({ formik, sourcePage, sourceStep }) => {
    const isConfirmStep = sourceStep === ShiftPostStep.CONFIRM
    const { values, errors, setFieldValue } = formik
    const [isOpen, toggleModal, closeModal] = useModal()

    /**
     * Field editing is disabled if template is not selected.
     */
    const editingDisabled =
      sourcePage === ShiftPostPage.POST_SHIFT && !values.template_id

    return (
      <SectionItem
        title="Number of Upshifters"
        hasEdit={isConfirmStep}
        isEditDisabled={editingDisabled}
        editDisabledTooltip="Please select a template first so you can edit the number of upshifters."
        onEdit={toggleModal}
      >
        {isConfirmStep && (
          <>
            <Text fontSize="medium" mt="xs" color={Colors.dark}>
              {values.positions
                ? `${values.positions} Upshifters`
                : 'You have not selected any positions yet.'}
            </Text>

            {(errors.positions || values.positions === 0) && (
              <Text color="danger" fontSize="small" my="0">
                {errors.positions}
              </Text>
            )}
          </>
        )}

        {!isConfirmStep && (
          <Box mt="sm">
            <InputV2
              labelStyles={{
                color: '#868686',
                fontWeight: 400,
              }}
              leftElementStyles={{
                top: 8,
                left: -1,
              }}
              numberArrowIconColor="gray.400"
              numberArrowsWrapperStyles={{
                right: 3,
              }}
              type="number"
              name="positions"
              id="positions"
              width="200px"
              value={values.positions}
              onChange={e => {
                const rawValue = e.target.value
                if (rawValue === '') {
                  setFieldValue('positions', rawValue)
                } else {
                  let val = Number(rawValue)
                  if (val < 0) val = 0
                  setFieldValue('positions', val)
                }
              }}
              errorMessage={errors.positions}
            />
          </Box>
        )}

        <NumberUpshiftersModal isOpen={isOpen} closeModal={closeModal} />
      </SectionItem>
    )
  },
)
